import ReactStars from "react-rating-stars-component";
import React, { useEffect } from "react";
import "swiper/css";
import "swiper/css/pagination";
import { Autoplay, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import Common_Title from "../../common/common-title/Common_Title";
import "./What_Student_Say.css";
import { useDispatch, useSelector } from "react-redux";
import { GetAllfeedback } from "../../../redux/aboutus";

const What_Student_Say = ({ feedback }) => {
  const testimonials = [
    {
      name: "Priya Mehta",
      location: "Pune Maharashtra",
      image: "/assets/images/home/testimonials/img.png",
      quote: "/assets/images/home/testimonials/blue-quote.png",
      review:
        "The parental counselling session gave us clarity about courses, entrance exams, and long-term career planning.",
      rating: 4.5,
    },
    {
      name: "Priya Mehta",
      location: "Pune Maharashtra",
      image: "/assets/images/home/testimonials/img.png",
      quote: "/assets/images/home/testimonials/pink-quote.png",
      review:
        "The career assessment helped me understand my strengths clearly. The counselling session gave me confidence.",
      rating: 5.0,
    },
    {
      name: "Priya Mehta",
      location: "Pune Maharashtra",
      image: "/assets/images/home/testimonials/img.png",
      quote: "/assets/images/home/testimonials/blue-quote.png",
      review:
        "The career assessment helped me understand my strengths clearly. The counselling session gave me confidence.",
      rating: 4.5,
    },
    {
      name: "Mrs. Kavita Sing",
      location: "Pune Maharashtra",
      image: "/assets/images/home/testimonials/img.png",
      quote: "/assets/images/home/testimonials/pink-quote.png",
      review:
        "The career assessment helped me understand my strengths clearly. The counselling session gave me confidence.",
      rating: 4.5,
    },
  ];

  var HtmlToReactParser = require("html-to-react").Parser;
  var htmlToReactParser = new HtmlToReactParser();

  return (
    <section className="What_Student_Say">
      <div className="container">
        <Common_Title
          title="What Students & Parents "
          subtitle="Say About Us "
        />

        <div className="testimonial_swiper">
          <Swiper
            modules={[Pagination, Autoplay]}
            loop
            slidesPerView={3}
            spaceBetween={30}
            pagination={{ clickable: true }}
            // autoplay={{ delay: 3000, reverseDirection: true }}
            breakpoints={{
              0: { slidesPerView: 1 },
              320: { slidesPerView: 1.2 },
              575: { slidesPerView: 2 },
              768: { slidesPerView: 2 },
              992: { slidesPerView: 3 },
            }}
          >
            {feedback?.map((item, index) => (
              <SwiperSlide key={index}>
                <div className="testimonial-card">
                  <div className="quote_wrapper">
                    <img
                      src={process.env.REACT_APP_IMG_URL + item?.icon}
                      alt="quote"
                      className="quote-img"
                    />
                  </div>

                  <div className="testimonial-header">
                    <img
                      src={process.env.REACT_APP_IMG_URL + item?.image}
                      alt={item?.name}
                    />

                    <div>
                      <h5>{item?.name}</h5>
                      <span>{item?.location}</span>

                      <div className="stars">
                        <ReactStars
                          count={5}
                          value={item?.rating}
                          size={20}
                          isHalf={true}
                          edit={true}
                          activeColor="#ffd700"
                        />
                        {/* <small>{item?.rating}</small> */}
                      </div>
                    </div>
                  </div>

                  <p className="testimonial-text">
                    <td>{htmlToReactParser.parse(item?.subject)}</td>
                  </p>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </section>
  );
};

export default What_Student_Say;
